
import moment from 'moment-timezone'

import { mapState, mapGetters } from 'vuex'

import { createEvent } from 'ics'

import {
  ROUTE_NAME_RESERVATIONS,
  ROUTE_URL_MODIFY,
  ROUTE_URL_CANCEL,
  ROUTE_PARAM_RESERVATION_ID,
  ROUTE_NAME_MODIFY_WAITLIST,
} from '@/router'

import Reservation from '@/components/Reservation.vue'
import ReservationStatusWrapper from '@/components/ReservationStatusWrapper.vue'

export default {
  name: 'ConfirmReservation',
  components: {
    Reservation,
    ReservationStatusWrapper,
  },
  async beforeCreate() {
    if (!this.$route.params[ROUTE_PARAM_RESERVATION_ID]) {
      this.$router.replace({ name: ROUTE_NAME_RESERVATIONS })
      return
    }

    if (this.$store.state.api.getReservationPromise) {
      await this.$store.state.api.getReservationPromise
    }
  },
  created() {
    if (this.$store.state.api.reservation.previousReservationState) {
      this.$store.dispatch('api/updateReservation', {
        ...this.$store.state.api.reservation.previousReservationState,
        previousReservationState: undefined,
      })
    }
    if (!this.reservation.waitlist) {
      this.createCalendarDownload()
    }
  },
  methods: {
    createCalendarDownload() {
      if (!this.reservation.day) {
        return
      }
      const dateInMerchantTimezone = moment(this.reservation.day.value)
        .set('hour', this.reservation.time?.value?.[0])
        .set('minute', this.reservation.time?.value?.[1])

      createEvent(
        {
          title: `Reservation at ${this.merchant.name}`,
          location: this.merchant.address,
          start: [
            dateInMerchantTimezone.get('year'),
            dateInMerchantTimezone.get('month') + 1, // Library expects dates in readable format
            dateInMerchantTimezone.get('date'),
            dateInMerchantTimezone.get('hour'),
            dateInMerchantTimezone.get('minute'),
          ],
          duration: { hours: 1 }, // TODO: get hours from API? turn_time_mins?
        },
        (error, value) => {
          if (error) {
            // TODO: display error?
            return
          }
          this.calendarDataUrl = `data:text/calendar;charset=utf8,${escape(
            value
          )}`
        }
      )
    },
  },
  data() {
    return {
      ROUTE_URL_CANCEL,
      calendarDataUrl: '',
    }
  },
  computed: {
    ...mapState({
      merchant: state => (state as any).api.merchant,
      reservation: state => (state as any).api.reservation,
      guest: state => (state as any).api.guest,
      getReservationPromise: state => (state as any).api.getReservationPromise,
    }),
    ...mapGetters({
      reservationCanceled: 'api/reservationCanceled',
    }),
    reservationPrice() {
      return (this.reservation.inventoryItem || {}).price
    },
    modifyRoute: {
      get() {
        if (this.reservationCanceled) {
          return {
            name: ROUTE_NAME_RESERVATIONS,
          }
        }

        return this.reservation.waitlist
          ? { name: ROUTE_NAME_MODIFY_WAITLIST }
          : { name: ROUTE_URL_MODIFY }
      },
    },
  },
}
